/* eslint-disable @typescript-eslint/no-explicit-any */
import Polyglot, { type InterpolationOptions } from 'node-polyglot';
import { cs } from './cs';
import { sk } from './sk';
import { type QueueStatus } from '../types/models/queue-model';
const polyglot = new Polyglot();
const phrases: any = {
  cs,
  sk
};

export type AppLocale = 'cs' | 'sk';

/**
 * Slovak for a phone set to Slovak, Czech for everything else. The first
 * Czech or Slovak entry in the browser's preference list decides, so a phone
 * set to English with Slovak second still gets Slovak.
 */
export function getLocale(): AppLocale {
  const preferred =
    typeof navigator === 'undefined'
      ? []
      : navigator.languages?.length
        ? navigator.languages
        : [navigator.language];
  for (const language of preferred) {
    const code = language?.toLowerCase() ?? '';
    if (code.startsWith('sk')) return 'sk';
    if (code.startsWith('cs')) return 'cs';
  }
  return 'cs';
}

function setLocale() {
  const locale = getLocale();
  polyglot.extend(phrases[locale]);
  polyglot.locale(locale);
  if (typeof document !== 'undefined') document.documentElement.lang = locale;
}

setLocale();

export function t(scope: string, options: InterpolationOptions = {}) {
  return polyglot.t(scope, options);
}

export function tError(scope: string, options = {}) {
  return polyglot.t(`errors.${scope}`, options);
}

export function tScreenTitle(key: string, options = {}) {
  return polyglot.t(`screen.${key}.title`, options);
}

export function tQueueStatus(queueStatus: QueueStatus) {
  return polyglot.t(`statuses.queueStatus.${queueStatus}`);
}
